function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, forwardRef } from "react";
import { Table, Tag, Row, Col, Image, Alert } from "antd";
import Moment from "react-moment";
import { Container } from "react-bootstrap";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var DisplayPo = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var po = _ref.po;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    itemsAr = _useState2[0],
    setItemsAr = _useState2[1];
  var cols = [{
    title: /*#__PURE__*/_jsx("b", {
      children: "D\xE9signation"
    }),
    dataIndex: "label",
    key: "label",
    render: function render(text) {
      return /*#__PURE__*/_jsx("span", {
        children: text
      });
    }
  }, _defineProperty(_defineProperty({
    title: /*#__PURE__*/_jsx("b", {
      children: "P.Unitaire"
    }),
    dataIndex: "price"
  }, "dataIndex", "price"), "render", function render(price) {
    return /*#__PURE__*/_jsx("span", {
      children: price.toLocaleString("Fr")
    });
  }), _defineProperty(_defineProperty({
    title: /*#__PURE__*/_jsx("b", {
      children: "Qte"
    }),
    dataIndex: "quantity"
  }, "dataIndex", "quantity"), "render", function render(qte) {
    return /*#__PURE__*/_jsx("span", {
      children: qte.toLocaleString("Fr")
    });
  }), _defineProperty(_defineProperty({
    title: /*#__PURE__*/_jsx("b", {
      children: "Total"
    }),
    dataIndex: "s_total"
  }, "dataIndex", "s_total"), "render", function render(t) {
    return /*#__PURE__*/_jsx("span", {
      children: t.toLocaleString("Fr")
    });
  })];
  useEffect(function () {
    po.purchase_order_items.forEach(function (item) {
      setItemsAr(function (prev) {
        return [].concat(_toConsumableArray(prev), [{
          key: item.id,
          label: item.llabel,
          price: item.price,
          quantity: item.quantity,
          s_total: item.price * item.quantity
        }]);
      });
    });
  }, []);
  return /*#__PURE__*/_jsxs(Container, {
    ref: ref,
    id: "printable",
    children: [/*#__PURE__*/_jsxs(Row, {
      children: [/*#__PURE__*/_jsx(Col, {
        span: 6,
        children: /*#__PURE__*/_jsx(Image, {
          preview: false,
          src: "/drawables/gsl-logo-long-tr.png",
          width: "100%"
        })
      }), /*#__PURE__*/_jsx(Col, {
        span: 16,
        offset: 2,
        children: /*#__PURE__*/_jsxs("div", {
          style: {
            textAlign: "center"
          },
          children: [/*#__PURE__*/_jsx("h2", {
            children: /*#__PURE__*/_jsx("b", {
              children: "GUISOFT Lab"
            })
          }), /*#__PURE__*/_jsx("div", {
            style: {
              color: "#C00000"
            },
            children: /*#__PURE__*/_jsx("b", {
              children: "Editeur de logiciel & Agence cr\xE9ative"
            })
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx("b", {
              children: " (+ 224) 620 14 95 56 ; Email : info@guisoftlab.com"
            })
          })]
        })
      })]
    }), /*#__PURE__*/_jsx("div", {
      style: {
        border: "4px solid #EE8742"
      }
    }), /*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsx(Col, {
        span: 7,
        offset: 17,
        children: /*#__PURE__*/_jsxs("div", {
          style: {
            marginTop: "10px",
            fontSize: "20px"
          },
          children: ["Conakry, le ", /*#__PURE__*/_jsx(Moment, {
            date: po.created_at,
            format: "DD/MM/YYYY"
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {})]
        })
      })
    }), /*#__PURE__*/_jsxs(Row, {
      children: [/*#__PURE__*/_jsx(Col, {
        span: 7,
        children: /*#__PURE__*/_jsxs("h3", {
          children: [/*#__PURE__*/_jsx("b", {
            children: "COMMANDE N\xB0: "
          }), " ", po.id]
        })
      }), /*#__PURE__*/_jsx(Col, {
        span: 15,
        offset: 2,
        children: /*#__PURE__*/_jsx("div", {
          style: {
            padding: "10px",
            background: "#735150"
          },
          children: /*#__PURE__*/_jsx("h3", {
            style: {
              textAlign: "center"
            },
            children: /*#__PURE__*/_jsx("b", {
              style: {
                color: "#FFF"
              },
              children: po.service_provider != null ? po.service_provider.label : "AUCUN FOURNISSEUR TROUVE"
            })
          })
        })
      })]
    }), /*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsxs(Col, {
        span: 24,
        children: [/*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Table, {
          dataSource: itemsAr,
          columns: cols,
          pagination: false,
          bordered: true
        }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("h4", {
          children: [/*#__PURE__*/_jsx("b", {
            children: "TOTAL :"
          }), " ", po.total_amount.toLocaleString("Fr"), " GNF"]
        }), /*#__PURE__*/_jsxs("h4", {
          children: [/*#__PURE__*/_jsx("b", {
            children: "REMISE :"
          }), " ", po.discount.toLocaleString("Fr"), " GNF"]
        }), /*#__PURE__*/_jsxs("h2", {
          children: [/*#__PURE__*/_jsx("b", {
            children: "MONTANT :"
          }), " ", (po.total_amount - po.discount).toLocaleString("Fr"), " GNF"]
        })]
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsx(Col, {
        span: 24,
        children: /*#__PURE__*/_jsx(Alert, {
          type: "info",
          showIcon: true,
          banner: true,
          message: /*#__PURE__*/_jsx("span", {
            children: po.payment_terms
          })
        })
      })
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
      style: {
        border: "1px solid #9C9898",
        padding: "7px"
      },
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          border: "4px solid #5B9BD5"
        }
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsxs(Col, {
          span: 10,
          children: [/*#__PURE__*/_jsx("b", {
            children: "Nom de la Banque : "
          }), /*#__PURE__*/_jsx("b", {
            style: {
              color: "#5B9BD5"
            },
            children: "ECOBANK"
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
            children: "N\xB0 de Compte : "
          }), /*#__PURE__*/_jsx("b", {
            style: {
              color: "#5B9BD5"
            },
            children: "7308054626"
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
            children: "Paiement \xE0 l\u2019ordre de : "
          }), /*#__PURE__*/_jsx("b", {
            style: {
              color: "#5B9BD5"
            },
            children: "GUISOFT LAB"
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
            children: "RIB : "
          }), /*#__PURE__*/_jsx("b", {
            style: {
              color: "#5B9BD5"
            },
            children: "010001730805462680"
          }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("b", {
            children: "Code Swift : "
          }), /*#__PURE__*/_jsx("b", {
            style: {
              color: "#5B9BD5"
            },
            children: "ECOCGNCN"
          }), /*#__PURE__*/_jsx("br", {})]
        }), /*#__PURE__*/_jsx(Col, {
          span: 10,
          offset: 4,
          children: /*#__PURE__*/_jsx("b", {
            children: "Adresse : Commune de Ratoma, Nongo Conteyah, N\xB0 Registre: GN.TCC.2021. B.11501"
          })
        })]
      }), /*#__PURE__*/_jsx("div", {
        style: {
          border: "4px solid #5B9BD5"
        }
      })]
    })]
  });
});
export default DisplayPo;